// Auto generated bg color for segmented buttons : Start
export const generateLighterColor = (color) => {
  const r = parseInt(color.substring(1, 3), 16);
  const g = parseInt(color.substring(3, 5), 16);
  const b = parseInt(color.substring(5, 7), 16);

  const lighterR = Math.round((r + 255) / 2.2);
  const lighterG = Math.round((g + 255) / 2.2);
  const lighterB = Math.round((b + 255) / 2.2);

  const lighterColor =
    '#' +
    lighterR.toString(16).padStart(2, '0') +
    lighterG.toString(16).padStart(2, '0') +
    lighterB.toString(16).padStart(2, '0');

  return lighterColor;
};

export const hashCode = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return hash;
};

export const intToRGB = (i) => {
  const c = (i & 0x00ffffff).toString(16).toUpperCase();
  return '00000'.substring(0, 6 - c.length) + c;
};

export function stringToColor(str) {
  const hash = hashCode(str);
  const rgb = intToRGB(hash);
  const color = `#${rgb}`;
  return generateLighterColor(color);
}

export const generateColor = (practitionerName) => {
  const primaryHash = hashCode(practitionerName);
  const secondaryHash = hashCode(practitionerName + 'secondary');
  const tertiaryHash = primaryHash ^ secondaryHash;
  let color = '#' + intToRGB(tertiaryHash);

  // Get a lighter version of the color
  const lighterColor = generateLighterColor(color);

  return lighterColor;
};
